import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Show the mail item context menu by initiating the itemContextMenuState
 * @param anchor the anchor where the mouse/keyboard event happens
 * @param the list view store which contains itemContextMenuState
 */
export var showMailItemContextMenu = action('showMailItemContextMenu')(select({
    listViewStore: function () { return listViewStore; },
})(function showMailItemContextMenu(anchor, menuType, menuSource, state) {
    state.listViewStore.itemContextMenuState = {
        anchor: anchor,
        menuType: menuType,
        menuSource: menuSource,
    };
}));
/**
 * Hide the mail item context menu by clearing the itemContextMenuState
 */
export var hideMailItemContextMenu = action('hideMailItemContextMenu')(select({
    listViewStore: function () { return listViewStore; },
})(function hideMailItemContextMenu(state) {
    state.listViewStore.itemContextMenuState = null;
}));
//# sourceMappingURL=itemContextMenuActions.js.map